<template>
  <div class="typing-container">
    <div class="typing">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<style scoped lang="scss">
$dot-width: 10px;
$dot-color: $color-primary-500;
$speed: 1.5s;

.typing-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.typing {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  span {
    content: '';
    animation: blink $speed infinite;
    animation-fill-mode: both;
    height: $dot-width;
    width: $dot-width;
    background: $dot-color;
    border-radius: 50%;
    margin: 0 $dot-width * 0.5;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

@keyframes blink {
  0% {
    opacity: 0.1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}
</style>
